import { P } from 'components'
import BreadCrumbs from 'components/breadcrumbs'
import PMBSelect from 'components/PMBSelect'
import {
  CERTIFICATION_OPTIONS,
  VESSEL_OTHER_STATUS_OPTIONS,
  WPP_OPTIONS,
} from 'constants'
import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from 'features/private-views/address-book/addressBookSlice'
import InputAddressBook from 'features/private-views/address-book/InputAddressBook'
import ModalAddContact from 'features/private-views/address-book/ModalAddContact'
import { useSnackbar } from 'notistack'
import { useEffect, useMemo, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  CardBody,
  Container,
  FormGroup,
  Input,
  Label,
} from 'reactstrap'
import { toggleModalChangeProfile } from '../detail/detailSlice'
import { useFetchVesselsQuery } from '../list-vessels/vesselsListApiSlice'
import CardUploadImage from './CardUploadImage'
import {
  useCreationVesselMutation,
  useFetchAllCompaniesVesselQuery,
  useFetchAllFisheriesVesselQuery,
  useFetchAllGearsVesselQuery,
  useFetchAllPortsVesselQuery,
  useUpdateVesselMutation,
} from './formApiSlice'
import { setPayloadSlice, setUrlImageVessel } from './formSlice'
import './style.css'

const FormAddVessel = ({ row }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { tag } = useSelector((s) => s.vesselsList)
  const { urlImageVessel } = useSelector((s) => s.vesselsForm)
  const { isModalOpenAddAddressBook } = useSelector((e) => e.addressBook)
  const { ownerData } = useSelector((s) => s.dashboard)
  const ownerUserId = ownerData?.userId

  const [creationVessel, { isLoading: isLoadingCreate }] =
    useCreationVesselMutation()
  const [updateVessel, { isLoading: isLoadingUpdate }] =
    useUpdateVesselMutation()
  // GET ALL GEARS
  const { data: dataGears } = useFetchAllGearsVesselQuery()
  const gearsOptions =
    dataGears?.items?.map((gear) => ({
      value: gear.name,
      label: gear.name,
    })) || []
  // GET ALL GEARS
  const { data: dataFisheries } = useFetchAllFisheriesVesselQuery({
    page: 0,
  })
  const fisheriesOptions =
    dataFisheries?.items?.map((fishery) => ({
      value: fishery.id,
      label: fishery.name,
    })) || []
  // GET ALL PORTS
  const { data: dataPorts } = useFetchAllPortsVesselQuery({
    page: 0,
    size: 999,
  })
  const portsOptions =
    dataPorts?.items?.map((fishery) => ({
      value: fishery.id,
      label: fishery.name,
    })) || []

  const { refetch } = useFetchVesselsQuery({
    page: 0,
    size: 10,
    searchvalue: '',
  })
  // const [fetchVessels] = useLazyFetchVesselsQuery()

  let [page, setPage] = useState({ page: tag.page })
  const { enqueueSnackbar } = useSnackbar()

  const [errMsg, setErrMsg] = useState('')
  const [payload, setPayload] = useState({})
  const [isClick, setIsClick] = useState(false)
  const [certificationStatus, setCertificationStatus] = useState([])
  const [isShowImageEdit, setIsShowImageEdit] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const [selectedGear, setSelectedGear] = useState(null)
  const [selectedWPP, setSelectedWPP] = useState([])
  const [selectedCompanies, setSelectedCompanies] = useState([{}])
  const [searchCompany, setSearchCompany] = useState('')
  const [selectedFisheries, setSelectedFisheries] = useState([])
  const [selectedPorts, setSelectedPorts] = useState([])
  const [selectedContactOwner, setSelectedContactOwner] = useState(null)
  const [selectedContactCaptain, setSelectedContactCaptain] = useState(null)
  const [openAccordion, setOpenAccordion] = useState('1')

  const [savedOwners, setSavedOwners] = useState([])
  const [savedCaptains, setSavedCaptains] = useState([])

  const handleHasAnswered = () => {
    const fieldRequireds = [
      'vesselName',
      'licenseNumber',
      'ap2hiUVI',
      'linkImage',
      'ownerName',
      'captain',
      'vesselFlag',
      'vesselGT',
      'vesselType',
    ]

    const emptyFields = fieldRequireds.filter((field) => !payload?.[field])

    const invalidCompanies = selectedCompanies?.some(
      (company) => !company?.value,
    )

    if (emptyFields.length > 0 || invalidCompanies) {
      enqueueSnackbar('Harap lengkapi semua kolom wajib.', {
        variant: 'warning',
      })
      return false
    }

    return true
  }

  // HANDLE CERTIFICATION
  const handleCertificationChange = (e) => {
    const { checked, value } = e.target

    setCertificationStatus((prev) => {
      if (checked) {
        return [...prev, value]
      } else {
        return prev?.filter((status) => status !== value)
      }
    })
  }

  // HANDLE OTHER STATUS
  const [selectedStatuses, setSelectedStatuses] = useState(
    VESSEL_OTHER_STATUS_OPTIONS.reduce((acc, option) => {
      acc[option.value] = false
      return acc
    }, {}),
  )

  const handleStatusChange = (e) => {
    const { value, checked } = e.target
    setSelectedStatuses((prev) => ({
      ...prev,
      [value]: checked,
    }))
  }

  // GET DATA COMPANIES
  const { data: dataCompanies, refetch: refetchCompanies } =
    useFetchAllCompaniesVesselQuery({
      page: 0,
      size: 50,
      searchvalue: searchCompany,
    })

  // HANDLE FOR SEARCHING COMPANY
  const handleCompanySearch = (text) => {
    if (text?.trim() !== '' && text?.length > 3) {
      setSearchCompany(text)
      refetchCompanies()
    } else {
      setSearchCompany('')
      refetchCompanies()
    }
  }

  // HANDLE FOR ADD NEW COMPANY
  const handleAddCompany = () => {
    setSelectedCompanies([...selectedCompanies, {}])
  }

  // HANDLE CHANGES ON DROPDOWN OPTION BASED ON INDEX
  const handleCompanyChange = (selectedOption, index) => {
    const updatedOffices = [...selectedCompanies]
    updatedOffices[index] = selectedOption
    setSelectedCompanies(updatedOffices)
  }

  // REMOVE COMPANY BASED ON INDEX
  const handleRemoveCompany = (index) => {
    const updatedOffices = [...selectedCompanies]
    updatedOffices.splice(index, 1)
    setSelectedCompanies(updatedOffices)
  }

  // VALIDATE ALREADY SELECTED OR NOT
  const validateCompany = () => {
    return selectedCompanies?.some((office) => !office?.value)
  }

  // FILTER REMOVE FROM OPTIONS IF THE DATA ALREADY SELECTED
  const getFilteredOptions = () => {
    const selectedCompanyId = selectedCompanies
      .map((office) => office?.value)
      .filter(Boolean)
    return (
      dataCompanies?.items?.filter(
        (company) => !selectedCompanyId.includes(company.id),
      ) || []
    )
  }

  useEffect(() => {
    setPayload((prev) => ({
      ...prev,
      certStatus: JSON.stringify(certificationStatus).replaceAll('"', `'`),
    }))
  }, [certificationStatus])

  useEffect(() => {
    if (urlImageVessel) {
      setPayload((prev) => ({
        ...prev,
        linkImage: urlImageVessel,
      }))
    }
  }, [urlImageVessel])

  const idVessel = row?.id

  const handleSubmit = async () => {
    try {
      // SAVE TO LOCALSTORAGE FOR DATA OWNER NAME
      if (payload?.ownerName) {
        const ownerStorageKey = `vesselOwnerNameAddressBook-${ownerUserId}`
        const ownerStoredData = JSON.parse(
          localStorage.getItem(ownerStorageKey) || '[]',
        )

        const ownerContact = {
          relationName: payload.ownerName,
        }

        const filteredOwnerData = ownerStoredData.filter(
          (item) => item.relationName !== payload.ownerName,
        )
        filteredOwnerData.unshift(ownerContact)
        localStorage.setItem(
          ownerStorageKey,
          JSON.stringify(filteredOwnerData.slice(0, 3)),
        )
      }

      // SAVE TO LOCALSTORAGE FOR DATA CAPTAIN NAME
      if (payload?.captain) {
        const captainStorageKey = `vesselCaptainAddressBook-${ownerUserId}`
        const captainStoredData = JSON.parse(
          localStorage.getItem(captainStorageKey) || '[]',
        )

        const captainContact = {
          captainName: payload.captain,
        }

        const filteredCaptainData = captainStoredData.filter(
          (item) => item.captainName !== payload.captain,
        )
        filteredCaptainData.unshift(captainContact)
        localStorage.setItem(
          captainStorageKey,
          JSON.stringify(filteredCaptainData.slice(0, 3)),
        )
      }

      const adjustedPayload = {
        ...payload,
        vesselGear: selectedGear?.value ?? '',
        sharkPolicy: selectedStatuses.sharkPolicy ?? false,
        iuuList: selectedStatuses?.iuuList ?? false,
        codeOfConduct: selectedStatuses?.codeOfConduct ?? false,
        nameChangedStatus: selectedStatuses?.nameChangedStatus ?? false,
        radioStatus: selectedStatuses?.radioStatus ?? false,
        vmsChange: selectedStatuses?.vmsChange ?? false,
        trackerStatus: selectedStatuses?.trackerStatus ?? false,
        flagStateChange: selectedStatuses?.flagStateChange ?? false,
        eLogBook: selectedStatuses?.eLogBook ?? false,
        sticker: selectedStatuses?.sticker ?? false,
        portsList: selectedPorts?.length
          ? selectedPorts?.map((item) => item?.value)
          : null,
        fisheriesList: selectedFisheries?.length
          ? selectedFisheries?.map((item) => item?.value)
          : null,
        companiesList: selectedCompanies?.length
          ? selectedCompanies?.map((item) => item?.value)
          : null,
        wppRIList: selectedWPP?.length
          ? selectedWPP.map((item) => item?.value).join(', ')
          : null,
      }

      const res = row
        ? await updateVessel({ payload: adjustedPayload, id: idVessel })
        : await creationVessel(adjustedPayload)

      if (res?.error) {
        enqueueSnackbar(
          res?.error?.data?.meta?.message ||
            `Vessel gagal  ${idVessel ? 'dirubah' : 'ditambahkan'}!`,
          { variant: 'error' },
        )
        setErrMsg(res?.error?.data?.meta?.message)
      } else if (!res?.error) {
        if (idVessel) {
          dispatch(toggleModalChangeProfile())
        }
        refetch()
        enqueueSnackbar(
          `Vessel berhasil  ${idVessel ? 'dirubah' : 'ditambahkan'}!`,
          { variant: 'success' },
        )

        navigate('/vessels')
      }
    } catch (error) {
      console.warn(error)
      enqueueSnackbar(
        `Vessel gagal  ${idVessel ? 'dirubah' : 'ditambahkan'}!`,
        { variant: 'error' },
      )
    }
  }

  // HANDLE EDIT
  useMemo(() => {
    if (row) {
      const certStatusRaw = row?.certStatus
      const cleanedCertStatus =
        certStatusRaw && certStatusRaw.replace(/[\[\]']/g, '').trim().length > 0
          ? certStatusRaw
              .replace(/[\[\]']/g, '')
              .split(',')
              .map((status) => status.trim())
          : []

      setSelectedGear({
        value: row?.vesselGear,
        label: row?.vesselGear,
      })

      setSelectedStatuses({
        nameChangedStatus: row?.nameChangedStatus,
        radioStatus: row?.radioStatus,
        vmsChange: row?.vmsChange,
        sharkPolicy: row?.sharkPolicy,
        trackerStatus: row?.trackerStatus,
        iuuList: row?.iuuList,
        flagStateChange: row?.flagStateChange,
        codeOfConduct: row?.codeOfConduct,
        eLogBook: row?.eLogBook,
        sticker: row?.sticker,
      })

      setSelectedWPP(
        row?.wppRIList?.split(',')?.map((item) => ({
          value: item.trim(),
          label: item.trim(),
        })),
      )

      setSelectedCompanies(
        row?.companiesList?.map((item) => ({
          value: item.companiesId,
          label: item.companiesData?.name,
        })),
      )

      setSelectedFisheries(
        row?.fisheriesList?.map((item) => ({
          value: item?.fisheriesId,
          label: item?.fisheriesData?.name,
        })),
      )

      setSelectedPorts(
        row?.portsList?.map((item) => ({
          value: item?.portsId,
          label: item?.portsData?.name,
        })),
      )

      setSelectedContactOwner({
        relationName: row?.ownerName,
      })

      setSelectedContactCaptain({
        relationName: row?.captain,
      })

      setIsShowImageEdit(row?.linkImage ? true : false)
      setPayload(() => ({
        vesselName: row?.vesselName ?? '',
        licenseNumber: row?.licenseNumber ?? '',
        ap2hiUVI: row?.ap2hiUVI ?? '',
        linkImage: row?.linkImage ?? '',
        ownerName: row?.ownerName ?? '',
        captain: row?.captain ?? '',
        vesselFlag: row?.vesselFlag ?? '',
        vesselGT: row?.vesselGT ?? '',
        vesselGear: row?.vesselGear ?? '',
        vesselType: row?.vesselType ?? '',
        motrMark: row?.motrMark ?? '',
        district: row?.district ?? '',
        vesselLength: row?.vesselLength ?? '',
        horsePower: row?.horsePower ?? '',
        yearOfConstruct: row?.yearOfConstruct ?? '',
        placeOfConstruct: row?.placeOfConstruct ?? '',
        materialType: row?.materialType ?? '',
        engineType: row?.engineType ?? '',
        engineBrand: row?.engineBrand ?? '',

        // Sertifikat: Human Policy
        humanPolicyCertificateAgency: row?.humanPolicyCertificateAgency ?? '',
        humanPolicyCertificateStandart:
          row?.humanPolicyCertificateStandart ?? '',
        humanPolicyCertificateValue: row?.humanPolicyCertificateValue ?? '',
        humanPolicyCertificateIdentification:
          row?.humanPolicyCertificateIdentification ?? '',

        // Sertifikat: Harvest
        harvestCertificateAgency: row?.harvestCertificateAgency ?? '',
        harvestCertificateStandart: row?.harvestCertificateStandart ?? '',
        harvestCertificateValue: row?.harvestCertificateValue ?? '',
        harvestCertificateIdentification:
          row?.harvestCertificateIdentification ?? '',

        // Sertifikat: Fishing Authorization
        fishingAuthorizationCertificateAgency:
          row?.fishingAuthorizationCertificateAgency ?? '',
        fishingAuthorizationCertificateStandart:
          row?.fishingAuthorizationCertificateStandart ?? '',
        fishingAuthorizationCertificateValue:
          row?.fishingAuthorizationCertificateValue ?? '',
        fishingAuthorizationCertificateIdentification:
          row?.fishingAuthorizationCertificateIdentification ?? '',

        // Sertifikat: Harvest CoC
        harvestCoCCertificateAgency: row?.harvestCoCCertificateAgency ?? '',
        harvestCoCCertificateStandart: row?.harvestCoCCertificateStandart ?? '',
        harvestCoCCertificateValue: row?.harvestCoCCertificateValue ?? '',
        harvestCoCCertificateIdentification:
          row?.harvestCoCCertificateIdentification ?? '',

        // Sertifikat: Transhipment Authorization
        transhipmentAuthorizationCertificateAgency:
          row?.transhipmentAuthorizationCertificateAgency ?? '',
        transhipmentAuthorizationCertificateStandart:
          row?.transhipmentAuthorizationCertificateStandart ?? '',
        transhipmentAuthorizationCertificateValue:
          row?.transhipmentAuthorizationCertificateValue ?? '',
        transhipmentAuthorizationCertificateIdentification:
          row?.transhipmentAuthorizationCertificateIdentification ?? '',
      }))

      // Certification Status
      if (row?.certStatus) {
        setCertificationStatus(cleanedCertStatus)
      }
      // Set Image Vessel
      dispatch(setUrlImageVessel(row?.linkImage))
    }
  }, [row])

  // const styleRemoveImage = {
  //   position: 'absolute',
  //   top: '-8px',
  //   right: '-5px',
  //   zIndex: '10',
  //   backgroundColor: '#98A2B3',
  //   color: 'white',
  //   border: 'none',
  //   borderRadius: '50%',
  //   width: '24px',
  //   height: '24px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   cursor: 'pointer',
  // }

  // const handleRemoveImage = (e) => {
  //   setSelectedFile(e)
  //   dispatch(toggleModalDeleteFile())
  // }

  const normalizedCertificationStatus = certificationStatus.map((status) =>
    status.trim().toLowerCase(),
  )

  const handleSelectContact = (contact = {}, fieldName) => {
    if (fieldName === 'ownerName') {
      if (Object.keys(contact).length !== 0) {
        setSelectedContactOwner(contact)
      } else {
        setSelectedContactOwner(null)
      }
    } else {
      if (Object.keys(contact).length !== 0) {
        setSelectedContactCaptain(contact)
      } else {
        setSelectedContactCaptain(null)
      }
    }
    setPayload((prev) => ({
      ...prev,
      [fieldName]: contact?.relationName?.toUpperCase() ?? '',
    }))
  }

  const toggleOpenCloseAddContact = (field) => {
    dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
  }

  const onClickAddContact = (localSearch) => {
    dispatch(setSearchAddressBook(localSearch))
  }

  // HANDLE ADDRESS BOOK FROM LOCALSTORAGE
  useEffect(() => {
    const loadSavedContacts = () => {
      const ownerStorageKey = `vesselOwnerNameAddressBook-${ownerUserId}`
      const savedOwners = JSON.parse(
        localStorage.getItem(ownerStorageKey) || '[]',
      )
      setSavedOwners(savedOwners)

      const captainStorageKey = `vesselCaptainAddressBook-${ownerUserId}`
      const savedCaptains = JSON.parse(
        localStorage.getItem(captainStorageKey) || '[]',
      )
      setSavedCaptains(savedCaptains)
    }

    loadSavedContacts()
  }, [ownerUserId])

  const toggleAccordion = (id) => {
    if (openAccordion === id) {
      setOpenAccordion()
    } else {
      setOpenAccordion(id)
    }
  }

  return (
    <Container className="custom-container d-flex flex-column gap-3 py-3">
      {!idVessel && (
        <BreadCrumbs
          breadCrumbTitle="Master Kapal"
          breadCrumbParent2="Daftar Kapal"
          breadCrumbParent2Link={'/vessels'}
          breadCrumbActive="Tambah Kapal"
        />
      )}
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={toggleOpenCloseAddContact}
        isOutsideAddressBook
      />
      {/* INFORMASI UMUM */}

      <div
        style={{
          height: '80vh',
          flexDirection: 'column',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <Accordion open={openAccordion} toggle={toggleAccordion}>
            <AccordionItem>
              <AccordionHeader targetId="1">
                {/* {!row && ( */}
                <div className="">
                  <P size="large">Tambah Kapal</P>
                  <P className="mt-1" color={'#667085'}>
                    Informasi umum terkait informasi kapal.
                  </P>
                </div>
                {/* )} */}
              </AccordionHeader>
              <AccordionBody accordionId="1">
                <CardBody className="d-flex flex-column gap-2">
                  <FormGroup>
                    <Label className="text-sm">Vessel Name</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan nama kapal"
                      autoComplete="off"
                      name="vesselName"
                      id="vesselName"
                      data-testid="vessel-form-vessel-name"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value?.toUpperCase(),
                        }))
                      }}
                      value={payload?.vesselName ?? null}
                      invalid={!payload?.vesselName && isClick}
                      autoFocus
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="text-sm">Vessel Registration</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan nomor registrasi kapal"
                      autoComplete="off"
                      name="licenseNumber"
                      id="licenseNumber"
                      data-testid="vessel-form-license-number"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value?.toUpperCase(),
                        }))
                      }}
                      value={payload?.licenseNumber ?? null}
                      invalid={!payload?.licenseNumber && isClick}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="text-sm">UVI</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan nomor unik kapal"
                      autoComplete="off"
                      name="ap2hiUVI"
                      id="ap2hiUVI"
                      data-testid="vessel-form-uvi"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value?.toUpperCase(),
                        }))
                      }}
                      value={payload?.ap2hiUVI ?? null}
                      invalid={!payload?.ap2hiUVI && isClick}
                    />
                  </FormGroup>
                  <FormGroup>
                    {idVessel ? (
                      <div className="d-flex align-items-center justify-content-between">
                        <Label className="text-sm">Vessel Image</Label>
                        <Label
                          onClick={() => {
                            if (isShowImageEdit) {
                              setIsShowImageEdit(false)
                            } else {
                              setIsShowImageEdit(true)
                            }
                          }}
                          className="text-sm text-primary"
                          style={{ cursor: 'pointer' }}
                        >
                          {isShowImageEdit ? 'Ubah' : 'Batal'}
                        </Label>
                      </div>
                    ) : (
                      <Label className="text-sm">Vessel Image</Label>
                    )}
                    <div className="d-flex flex-wrap gap-3">
                      <div style={{ position: 'relative', width: '100%' }}>
                        {idVessel && isShowImageEdit ? (
                          <>
                            {/* WAITING BE TILL PROVIDE DELETE IMAGE */}
                            {/* {isShowImageEdit && (
                      <>
                        {' '}
                        <button
                          style={styleRemoveImage}
                          onClick={() => handleRemoveImage(e)}
                        >
                          X
                        </button>
                      </>
                    )} */}

                            <img
                              style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '400px',
                                maxWidth: '400px',
                              }}
                              className="img-fluid rounded"
                              src={urlImageVessel}
                              alt="IMAGE_VESSEL"
                              loading="lazy"
                            />
                          </>
                        ) : (
                          <>
                            <CardUploadImage
                              type="IMAGE_VESSEL"
                              className={`${!payload?.linkImage && isClick ? 'border-danger' : ''}`}
                            />
                          </>
                        )}
                      </div>
                    </div>
                    {/* <CardUploadImage
              type="IMAGE_VESSEL"
              className={`${!payload?.linkImage && isClick ? 'border-danger' : ''}`}
            /> */}
                  </FormGroup>
                  <div className="mb-3">
                    <InputAddressBook
                      className={'custom-placeholder'}
                      isVessel
                      key="ownerName"
                      title="Owner Name"
                      placeholderDesc="Pilih dari kontak Anda"
                      onSelectContact={handleSelectContact}
                      isUppercaseValue
                      fieldName="ownerName"
                      invalid={!payload?.ownerName && isClick}
                      onClickAdd={onClickAddContact}
                      editValue={
                        selectedContactOwner
                          ? selectedContactOwner?.relationPhoneNumber
                            ? `${selectedContactOwner?.relationName?.toUpperCase()} (${selectedContactOwner?.relationPhoneNumber})`
                            : selectedContactOwner?.relationEmail
                              ? `${selectedContactOwner?.relationName?.toUpperCase()} (${selectedContactOwner?.relationEmail})`
                              : (selectedContactOwner?.relationName?.toUpperCase() ??
                                '')
                          : ''
                      }
                      isNetwork
                    />

                    {/* SAVED OWNER NAME */}
                    {savedOwners?.length > 0 && !selectedContactOwner && (
                      <div
                        className="d-flex gap-2 mt-4"
                        style={{ minWidth: '100%', overflow: 'auto' }}
                      >
                        {savedOwners.map((contact, i) => {
                          return (
                            <div
                              key={i}
                              onClick={() => {
                                setSelectedContactOwner({
                                  relationName: contact.relationName,
                                })
                                dispatch(
                                  setSearchAddressBook(contact.relationName),
                                )
                              }}
                              className="rounded p-3 bg-gray-50 hover-100 pointer"
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span>{contact.relationName}</span>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <InputAddressBook
                      className={'custom-placeholder'}
                      isVessel
                      key="captain"
                      title="Captain"
                      placeholderDesc="Pilih dari kontak Anda"
                      onSelectContact={handleSelectContact}
                      isUppercaseValue
                      fieldName="captain"
                      invalid={!payload?.captain && isClick}
                      onClickAdd={onClickAddContact}
                      editValue={
                        selectedContactCaptain
                          ? selectedContactCaptain?.relationPhoneNumber
                            ? `${selectedContactCaptain?.relationName?.toUpperCase()} (${selectedContactCaptain?.relationPhoneNumber})`
                            : selectedContactCaptain?.relationEmail
                              ? `${selectedContactCaptain?.relationName?.toUpperCase()} (${selectedContactCaptain?.relationEmail})`
                              : (selectedContactCaptain?.relationName?.toUpperCase() ??
                                '')
                          : ''
                      }
                      isNetwork
                    />

                    {/* SAVED CAPTAINS */}
                    {savedCaptains?.length > 0 && !selectedContactCaptain && (
                      <div
                        className="d-flex gap-2 mt-4"
                        style={{ minWidth: '100%', overflow: 'auto' }}
                      >
                        {savedCaptains.map((contact, i) => {
                          return (
                            <div
                              key={i}
                              onClick={() => {
                                setSelectedContactCaptain({
                                  relationName: contact.captainName,
                                })
                                dispatch(
                                  setSearchAddressBook(contact.captainName),
                                )
                              }}
                              className="rounded p-3 bg-gray-50 hover-100 pointer"
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span>{contact.captainName}</span>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </div>
                  <FormGroup>
                    <Label className="text-sm">Vessel Type</Label>
                    <Input
                      className={'custom-placeholder'}
                      placeholder="Masukkan tipe kapal"
                      autoComplete="off"
                      name="vesselType"
                      id="vesselType"
                      data-testid="vessel-form-vessel-type"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.vesselType ?? null}
                      invalid={!payload?.vesselType && isClick}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="text-sm">Vessel Flag</Label>
                    <Input
                      className={'custom-placeholder'}
                      placeholder="Masukkan bendera kapal"
                      autoComplete="off"
                      name="vesselFlag"
                      id="vesselFlag"
                      data-testid="vessel-form-vessel-flag"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value?.toUpperCase(),
                        }))
                      }}
                      value={payload?.vesselFlag ?? null}
                      invalid={!payload?.vesselFlag && isClick}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="text-sm">Vessel GT</Label>
                    <Input
                      className={'custom-placeholder'}
                      type="number"
                      min={0}
                      placeholder="Masukkan GT kapal"
                      autoComplete="off"
                      name="vesselGT"
                      id="vesselGT"
                      data-testid="vessel-form-vessel-gt"
                      onChange={(e) => {
                        const value = e.target.value
                        if (!isNaN(value)) {
                          setPayload((prev) => ({
                            ...prev,
                            [e.target.name]: value,
                          }))
                        }
                      }}
                      onKeyDown={(e) => {
                        if (
                          e.key === 'e' ||
                          e.key === 'E' ||
                          e.key === '+' ||
                          e.key === '-' ||
                          e.key === '.' ||
                          e.key === ','
                        ) {
                          e.preventDefault()
                        }
                      }}
                      value={payload?.vesselGT ?? null}
                      invalid={!payload?.vesselGT && isClick}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="text-sm">Gear</Label>
                    <PMBSelect
                      value={selectedGear}
                      onChange={(selectedOptions) =>
                        setSelectedGear(selectedOptions)
                      }
                      options={gearsOptions}
                      isInvalid={isClick && !selectedGear}
                      placeholder="Pilih gear yang digunakan"
                      testId="vessel-form-gear"
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">MOTR Mark</Label>
                    <Input
                      className={'custom-placeholder'}
                      placeholder="Masukkan MOTR mark"
                      autoComplete="off"
                      name="motrMark"
                      id="motrMark"
                      data-testid="vessel-form-motr-mark"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.motrMark ?? null}
                      invalid={!payload?.motrMark && isClick}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Certification Status</Label>

                    {CERTIFICATION_OPTIONS.map((option, index) => {
                      const normalizedValue = option?.value
                        ?.trim()
                        .toLowerCase()
                      const isChecked =
                        normalizedCertificationStatus?.includes(normalizedValue)

                      return (
                        <div
                          key={index}
                          className="d-flex w-full p-3 rounded mb-2"
                          style={{
                            color: isChecked ? '#004259' : '',
                            backgroundColor: isChecked ? '#ECFAFF' : '',
                            borderColor: isChecked ? '#004259' : '#ccc',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                          }}
                        >
                          <FormGroup check>
                            <Input
                              type="checkbox"
                              value={option.value}
                              onChange={handleCertificationChange}
                              checked={isChecked}
                            />
                            <Label className="text-sm" check>
                              {option.label}
                            </Label>
                          </FormGroup>
                        </div>
                      )
                    })}
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Other Status</Label>

                    {VESSEL_OTHER_STATUS_OPTIONS.map((option, index) => {
                      const isChecked = selectedStatuses[option.value]
                      return (
                        <div
                          key={index}
                          className="d-flex w-full p-3 rounded mb-2"
                          style={{
                            color: isChecked ? '#004259' : '',
                            backgroundColor: isChecked ? '#ECFAFF' : '',
                            borderColor: isChecked ? '#004259' : '#ccc',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                          }}
                        >
                          <FormGroup check>
                            <Input
                              type="checkbox"
                              value={option.value}
                              onChange={handleStatusChange}
                              checked={isChecked}
                            />
                            <Label className="text-sm" check>
                              {option.label}
                            </Label>
                          </FormGroup>
                        </div>
                      )
                    })}
                  </FormGroup>
                </CardBody>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          {/* END INFORMASI UMUM */}

          {/* PEMETAAN KAPAL */}
          <Accordion
            open={openAccordion}
            toggle={toggleAccordion}
            className="mt-3"
          >
            <AccordionItem>
              <AccordionHeader targetId="2">
                <div className="">
                  <P size="large">Pemetaan Kapal</P>
                  <P className="mt-1" color={'#667085'}>
                    Informasi yang menghubungkan kapal dengan beberapa entitas
                    lainnya.
                  </P>
                </div>
              </AccordionHeader>
              <AccordionBody accordionId="2">
                <CardBody className="d-flex flex-column gap-2">
                  <FormGroup>
                    <Label>WPP-RI</Label>
                    <PMBSelect
                      placeholderColor={'#c5c5c5'}
                      value={selectedWPP}
                      onChange={(selectedOptions) =>
                        setSelectedWPP(selectedOptions)
                      }
                      options={WPP_OPTIONS}
                      isInvalid={isClick && !selectedWPP?.length}
                      placeholder="Pilih WPP"
                      isMulti
                      className="custom-placeholder"
                      testId="vessel-form-wpp"
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">District</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan District"
                      autoComplete="off"
                      name="district"
                      id="district"
                      data-testid="vessel-form-district"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value?.toUpperCase(),
                        }))
                      }}
                      value={payload?.district ?? null}
                      invalid={!payload?.district && isClick}
                    />
                  </FormGroup>

                  {/* COMPANY */}
                  <FormGroup>
                    <Label className="text-sm">Company</Label>
                    {selectedCompanies?.map((office, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between mb-2"
                      >
                        <div style={{ flexGrow: 1 }}>
                          <PMBSelect
                            placeholderColor={'#c5c5c5'}
                            value={office}
                            onChange={(selectedOption) =>
                              handleCompanyChange(selectedOption, index)
                            }
                            options={getFilteredOptions()?.map((company) => ({
                              value: company.id,
                              label: company.name,
                            }))}
                            onInputChange={handleCompanySearch}
                            placeholder="Pilih perusahaan..."
                            isInvalid={isClick && !office?.value}
                            testId={`vessel-form-company-${index}`}
                          />
                        </div>
                        <Button
                          color="danger"
                          className="ms-2"
                          onClick={() => handleRemoveCompany(index)}
                          disabled={selectedCompanies.length === 1}
                          data-testid={`vessel-form-company-remove-${index}`}
                        >
                          X
                        </Button>
                      </div>
                    ))}

                    {/* ADD NEW SUPPORTING OFFICE */}
                    <Button
                      color="primary"
                      onClick={handleAddCompany}
                      className="mt-2 text-sm"
                      disabled={validateCompany()}
                      data-testid="vessel-form-add-company"
                    >
                      Tambah Company
                    </Button>
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Fishery</Label>
                    <PMBSelect
                      value={selectedFisheries}
                      placeholderColor={'#c5c5c5'}
                      onChange={(selectedOptions) =>
                        setSelectedFisheries(selectedOptions)
                      }
                      options={fisheriesOptions}
                      isInvalid={isClick && !selectedFisheries?.length}
                      placeholder="Pilih fishery"
                      isMulti
                      testId="vessel-form-fishery"
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Port</Label>
                    <PMBSelect
                      placeholderColor={'#c5c5c5'}
                      value={selectedPorts}
                      onChange={(selectedOptions) =>
                        setSelectedPorts(selectedOptions)
                      }
                      options={portsOptions}
                      isInvalid={isClick && !selectedPorts?.length}
                      placeholder="Pilih port"
                      isMulti
                      testId="vessel-form-port"
                    />
                  </FormGroup>
                </CardBody>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          {/* END PEMETAAN KAPAL */}

          {/* DETAIL ATRIBUT KAPAL */}
          <Accordion
            open={openAccordion}
            toggle={toggleAccordion}
            className="mt-3"
          >
            <AccordionItem>
              <AccordionHeader targetId="3">
                <div className="">
                  <P size="large">Detail Atribut Kapal</P>
                  <P className="mt-1" color={'#667085'}>
                    Informasi lainnya terkait dengan informasi kapal.
                  </P>
                </div>
              </AccordionHeader>
              <AccordionBody accordionId="3">
                <CardBody className="d-flex flex-column gap-2">
                  <FormGroup>
                    <Label className="text-sm">Length</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan panjang kapal"
                      autoComplete="off"
                      name="vesselLength"
                      id="vesselLength"
                      data-testid="vessel-form-vessel-length"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.vesselLength ?? null}
                      // invalid={!payload?.vesselLength && isClick}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Horse Power</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan horse power kapal"
                      autoComplete="off"
                      name="horsePower"
                      id="horsePower"
                      data-testid="vessel-form-horse-power"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.horsePower ?? null}
                      // invalid={!payload?.horsePower && isClick}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Year of Construction</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan tanggal pembuatan kapal"
                      autoComplete="off"
                      name="yearOfConstruct"
                      id="yearOfConstruct"
                      data-testid="vessel-form-year-of-construct"
                      // type="date" // DATE OR TEXTFIELD
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.yearOfConstruct ?? null}
                      // invalid={!payload?.yearOfConstruct && isClick}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Place of Construction</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan lokasi pembuatan kapal"
                      autoComplete="off"
                      name="placeOfConstruct"
                      id="placeOfConstruct"
                      data-testid="vessel-form-place-of-construct"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.placeOfConstruct ?? null}
                      // invalid={!payload?.placeOfConstruct && isClick}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Material Type</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan jenis material dari kapal"
                      autoComplete="off"
                      name="materialType"
                      id="materialType"
                      data-testid="vessel-form-material-type"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.materialType ?? null}
                      // invalid={!payload?.materialType && isClick}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="text-sm">Engine Brand</Label>
                    <Input
                      className="custom-placeholder"
                      placeholder="Masukkan brand kapal"
                      autoComplete="off"
                      name="engineBrand"
                      id="engineBrand"
                      data-testid="vessel-form-engine-brand"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.value,
                        }))
                      }}
                      value={payload?.engineBrand ?? null}
                      // invalid={!payload?.engineBrand && isClick}
                    />
                  </FormGroup>
                </CardBody>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          {/* END ATRIBUT KAPAL */}

          <Accordion
            open={openAccordion}
            toggle={toggleAccordion}
            className="mt-3"
          >
            <AccordionItem>
              <AccordionHeader targetId="4">
                <div className="">
                  <P size="large">Dokumen Sertifikasi Kapal</P>
                  <P className="mt-1" color={'#667085'}>
                    Isi informasi sertifikasi yang berkaitan dengan kebijakan
                    SDM, panen, otorisasi penangkapan, CoC, dan transshipment
                    kapal.
                  </P>
                </div>
              </AccordionHeader>
              <AccordionBody accordionId="4">
                <FormGroup>
                  <Label className="text-sm">
                    Human Policy Certificate Agency
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nama lembaga sertifikat Human Policy"
                    autoComplete="off"
                    name="humanPolicyCertificateAgency"
                    id="humanPolicyCertificateAgency"
                    data-testid="vessel-form-human-policy-certificate-agency"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.humanPolicyCertificateAgency ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Human Policy Certificate Standart
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan standar sertifikat Human Policy"
                    autoComplete="off"
                    name="humanPolicyCertificateStandart"
                    id="humanPolicyCertificateStandart"
                    data-testid="vessel-form-human-policy-certificate-standart"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.humanPolicyCertificateStandart ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Human Policy Certificate Value
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nilai sertifikat Human Policy"
                    autoComplete="off"
                    name="humanPolicyCertificateValue"
                    id="humanPolicyCertificateValue"
                    data-testid="vessel-form-human-policy-certificate-value"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.humanPolicyCertificateValue ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Human Policy Certificate Identification
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan identifikasi sertifikat Human Policy"
                    autoComplete="off"
                    name="humanPolicyCertificateIdentification"
                    id="humanPolicyCertificateIdentification"
                    data-testid="vessel-form-human-policy-certificate-identification"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.humanPolicyCertificateIdentification ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">Harvest Certificate Agency</Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nama lembaga sertifikat Harvest"
                    autoComplete="off"
                    name="harvestCertificateAgency"
                    id="harvestCertificateAgency"
                    data-testid="vessel-form-harvest-certificate-agency"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCertificateAgency ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Harvest Certificate Standart
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan standar sertifikat Harvest"
                    autoComplete="off"
                    name="harvestCertificateStandart"
                    id="harvestCertificateStandart"
                    data-testid="vessel-form-harvest-certificate-standart"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCertificateStandart ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">Harvest Certificate Value</Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nilai sertifikat Harvest"
                    autoComplete="off"
                    name="harvestCertificateValue"
                    id="harvestCertificateValue"
                    data-testid="vessel-form-harvest-certificate-value"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCertificateValue ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Harvest Certificate Identification
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan identifikasi sertifikat Harvest"
                    autoComplete="off"
                    name="harvestCertificateIdentification"
                    id="harvestCertificateIdentification"
                    data-testid="vessel-form-harvest-certificate-identification"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCertificateIdentification ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Fishing Authorization Certificate Agency
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nama lembaga sertifikat Otorisasi Penangkapan"
                    autoComplete="off"
                    name="fishingAuthorizationCertificateAgency"
                    id="fishingAuthorizationCertificateAgency"
                    data-testid="vessel-form-fishing-authorization-certificate-agency"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.fishingAuthorizationCertificateAgency ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Fishing Authorization Certificate Standart
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan standar sertifikat Otorisasi Penangkapan"
                    autoComplete="off"
                    name="fishingAuthorizationCertificateStandart"
                    id="fishingAuthorizationCertificateStandart"
                    data-testid="vessel-form-fishing-authorization-certificate-standart"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={
                      payload?.fishingAuthorizationCertificateStandart ?? ''
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Fishing Authorization Certificate Value
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nilai sertifikat Otorisasi Penangkapan"
                    autoComplete="off"
                    name="fishingAuthorizationCertificateValue"
                    id="fishingAuthorizationCertificateValue"
                    data-testid="vessel-form-fishing-authorization-certificate-value"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.fishingAuthorizationCertificateValue ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Fishing Authorization Certificate Identification
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan identifikasi sertifikat Otorisasi Penangkapan"
                    autoComplete="off"
                    name="fishingAuthorizationCertificateIdentification"
                    id="fishingAuthorizationCertificateIdentification"
                    data-testid="vessel-form-fishing-authorization-certificate-identification"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={
                      payload?.fishingAuthorizationCertificateIdentification ??
                      ''
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Harvest CoC Certificate Agency
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nama lembaga sertifikat Harvest CoC"
                    autoComplete="off"
                    name="harvestCoCCertificateAgency"
                    id="harvestCoCCertificateAgency"
                    data-testid="vessel-form-harvest-coc-certificate-agency"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCoCCertificateAgency ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Harvest CoC Certificate Standart
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan standar sertifikat Harvest CoC"
                    autoComplete="off"
                    name="harvestCoCCertificateStandart"
                    id="harvestCoCCertificateStandart"
                    data-testid="vessel-form-harvest-coc-certificate-standart"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCoCCertificateStandart ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Harvest CoC Certificate Value
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nilai sertifikat Harvest CoC"
                    autoComplete="off"
                    name="harvestCoCCertificateValue"
                    id="harvestCoCCertificateValue"
                    data-testid="vessel-form-harvest-coc-certificate-value"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCoCCertificateValue ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Harvest CoC Certificate Identification
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan identifikasi sertifikat Harvest CoC"
                    autoComplete="off"
                    name="harvestCoCCertificateIdentification"
                    id="harvestCoCCertificateIdentification"
                    data-testid="vessel-form-harvest-coc-certificate-identification"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={payload?.harvestCoCCertificateIdentification ?? ''}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Transhipment Authorization Certificate Agency
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nama lembaga sertifikat Otorisasi Transhipment"
                    autoComplete="off"
                    name="transhipmentAuthorizationCertificateAgency"
                    id="transhipmentAuthorizationCertificateAgency"
                    data-testid="vessel-form-transhipment-authorization-certificate-agency"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={
                      payload?.transhipmentAuthorizationCertificateAgency ?? ''
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Transhipment Authorization Certificate Standart
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan standar sertifikat Otorisasi Transhipment"
                    autoComplete="off"
                    name="transhipmentAuthorizationCertificateStandart"
                    id="transhipmentAuthorizationCertificateStandart"
                    data-testid="vessel-form-transhipment-authorization-certificate-standart"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={
                      payload?.transhipmentAuthorizationCertificateStandart ??
                      ''
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Transhipment Authorization Certificate Value
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan nilai sertifikat Otorisasi Transhipment"
                    autoComplete="off"
                    name="transhipmentAuthorizationCertificateValue"
                    id="transhipmentAuthorizationCertificateValue"
                    data-testid="vessel-form-transhipment-authorization-certificate-value"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={
                      payload?.transhipmentAuthorizationCertificateValue ?? ''
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="text-sm">
                    Transhipment Authorization Certificate Identification
                  </Label>
                  <Input
                    className="custom-placeholder"
                    placeholder="Masukkan identifikasi sertifikat Otorisasi Transhipment"
                    autoComplete="off"
                    name="transhipmentAuthorizationCertificateIdentification"
                    id="transhipmentAuthorizationCertificateIdentification"
                    data-testid="vessel-form-transhipment-authorization-certificate-identification"
                    onChange={(e) => {
                      setPayload((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value?.toUpperCase(),
                      }))
                    }}
                    value={
                      payload?.transhipmentAuthorizationCertificateIdentification ??
                      ''
                    }
                  />
                </FormGroup>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>
        <div className="pt-2 pb-2">
          <span className="text-semibold">
            Dengan {row ? 'merubah' : 'mendaftarkan'} kapal, saya menjamin
            kebenaran data yang dimasukkan dan bertanggung jawab atas
            ketidaksesuaian data.
          </span>

          {errMsg && (
            <small className="text-danger">
              <AlertCircle size={15} /> {errMsg}
            </small>
          )}

          <div className="d-flex gap-3 mt-3">
            {row ? (
              <Button
                onClick={() => {
                  dispatch(toggleModalChangeProfile())
                }}
                outline
                className="btn-cancel"
                block
                data-testid="vessel-form-cancel-button"
              >
                Batal
              </Button>
            ) : (
              <></>
            )}

            {!row && (
              <Button
                onClick={() => navigate('/vessels')}
                outline
                className="btn-cancel"
                block
                data-testid="vessel-form-cancel-button"
              >
                Batal
              </Button>
            )}
            <Button
              disabled={isLoadingCreate}
              onClick={() => {
                const res = handleHasAnswered()
                setIsClick(true)
                if (res) {
                  setIsClick(false)
                  dispatch(setPayloadSlice(payload))
                  handleSubmit()
                }
              }}
              color="primary"
              block
              data-testid="vessel-form-submit-button"
            >
              Simpan
            </Button>
          </div>
        </div>
      </div>
    </Container>
  )
}

// ;<div className="d-flex gap-3">
//   <Button
//     onClick={() => {
//       toggle()
//       resetState()
//     }}
//     color="primary"
//     outline
//     block
//   >
//     Batal
//   </Button>
//   <Button
//     disabled={
//       resUpdateFishItem?.isLoading ||
//       !payload?.amount ||
//       Number(payload?.amount) === 0 ||
//       Number(payload?.amount) === Number(row?.amount)
//     }
//     color="primary"
//     block
//     onClick={handleSubmit}
//   >
//     Simpan
//   </Button>
// </div>

export default FormAddVessel
